jQuery( function( $ ) {
  $( document ).ready( function() {
    const row = Math.floor( Math.random() * 5 );

    var $rows = $( '.random-row' );
    $rows[row].classList.add( 'random-show' );
  });
});
